import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateCalendarContactCreationRule as UpdateCalendarContactCreationRuleMutation,
    UpdateCalendarContactCreationRuleVariables as UpdateCalendarContactCreationRuleVariables,
} from 'nutshell-graphql-types';

import UPDATE_CALENDAR_CONTACT_CREATION_RULE from '../mutations/update-calendar-contact-creation-rule.graphql';

export const useUpdateCalendarContactCreationRule = (): {
    updateCalendarContactCreationRule: (
        input: UpdateCalendarContactCreationRuleVariables
    ) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateCalendarContactCreationRule, {loading, error}] = useMutation<
        UpdateCalendarContactCreationRuleMutation,
        UpdateCalendarContactCreationRuleVariables
    >(UPDATE_CALENDAR_CONTACT_CREATION_RULE);

    return {
        updateCalendarContactCreationRule: (input: UpdateCalendarContactCreationRuleVariables) =>
            updateCalendarContactCreationRule({
                variables: input,
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
